/**
 * 工作流设计相关函数
 */
import {getDate} from '@/api/Select'
import {flattenProcessNode} from '@/utils/flattenProcessNode.js'
import store from '@/store'
import VueCookies from 'vue-cookies'
 
const v_url_base =  'xuper_auth/getBaseData'  
const v_url_update =  'xuper_auth/updateRec' 

const v_url_save =   'xuper_auth/formOneSave' 

const v_url_dtl_save =   'xuper_auth/tableBodySave' 

const v_url_batch_save =   'xuper_auth/batDtlSave2' 

const v_url_delete =  'xuper_auth/delTabRec' 

const v_url_wx_message =  'xuper_auth/sendWxTemplateMessage' 

function getCorpid() {
    return VueCookies.get('v_corpid');
}

/**
 * 记录审批日志到 SYS_FLOW_APPLOG 表
 * 日志记录规则：
 * - IDSEQ: 使用businessId(业务单据ID)
 * - STFG: 只有Y(通过)和N(驳回)两种状态
 * - LOGTY: F(发起人), C(抄送人), A(审批人)
 * - RMK: 标准化操作描述
 * - REFLSTSEQ: 关联SYS_FLOW_APPUSER.LSTSEQ
 * @param {Object} options - 配置选项
 * @param {string} options.businessId - 业务单据ID
 * @param {string} options.empno - 操作人工号
 * @param {string} options.empnm - 操作人姓名
 * @param {string} options.stfg - 状态：'Y'(通过)或'N'(驳回)
 * @param {string} options.rmk - 操作备注
 * @param {string} options.logty - 日志类型：'F'(发起人),'A'(审批人),'C'(抄送人)
 * @param {string} options.refLstseq - 关联的SYS_FLOW_APPUSER.LSTSEQ（可选）
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 */
export function recordApprovalLog(options) {

    const {businessId, empno, empnm, stfg, rmk, logty, refLstseq, axios, baseUrl,CHKRMK} = options;

    const logData = {
        IDSEQ: businessId,
        EMPNO: empno,
        EMPNM: empnm,
        APPDTTM: getDate('full'),
        STFG: stfg,
        RMK: rmk || '',
        LOGTY: logty,
        CHKRMK:CHKRMK,
        REFLSTSEQ: refLstseq || '',
        ADDUSER: localStorage.getItem('v_usernm'),
        ADDDTTM: getDate('full'),
        UPDUSER: localStorage.getItem('v_usernm'),
        UPDDTTM: getDate('full')
    };

    return axios({
        method: 'post',
        url: v_url_dtl_save,
        data: {
            p_json: JSON.stringify(logData),
            p_table: 'SYS_flow_applog',
            p_idseq: businessId
        }
    }).then(() => {
        return true;
    }).catch(error => {
        throw new Error(`记录审批日志失败: ${error.message}`);
    });
}

/**
 * 简化的审批日志记录函数
 * @param {string} businessId - 审批记录的主键ID
 * @param {string} empno - 操作人工号
 * @param {string} empnm - 操作人姓名
 * @param {string} operation - 操作类型：'initiate'(发起-F), 'approve'(通过-A), 'reject'(驳回-A), 'cc'(抄送-C)
 * @param {string} refLstseq - 关联的SYS_FLOW_APPUSER.LSTSEQ（可选）
 * @param {Object} axios - axios实例
 * @param {string} baseUrl - API基础URL
 */
export async function logApprovalOperation(businessId, empno, empnm, operation, refLstseq, axios, baseUrl) {
    const operationMap = {
        'initiate': {stfg: 'Y', rmk: '发起人 发起', logty: 'F'},
        'approve': {stfg: 'Y', rmk: '审核人 通过', logty: 'A'},
        'reject': {stfg: 'N', rmk: '审核人 驳回', logty: 'R'},
        'cc': {stfg: 'Y', rmk: '抄送人 接收', logty: 'C'}
    };

    const config = operationMap[operation];
    if (!config) {
        throw new Error(`未知的操作类型: ${operation}`);
    }

    return await recordApprovalLog({
        businessId,
        empno,
        empnm,
        stfg: config.stfg,
        rmk: config.rmk,
        logty: config.logty,
        refLstseq,
        axios,
        baseUrl
    });
}

/**
 * 发送微信模板消息
 */
export async function sendWeChatTemplateMessage(options) {
    const {businessId, initiator, CNAME, DIRNM, axios, baseUrl} = options;

    try {

        const appUserQuery = await axios({
            method: 'post',
            url: v_url_base,
            data: {
                p_table: 'V_SYS_FLOW_APPUSER',
                p_key: 'IDSEQ',
                p_value: businessId,
                p_key2: 'corpid',
                p_value2: getCorpid(),
                p_where: `AND ISCC = '0' AND STFG = 'N'`,
                p_orderby: 'APPSORT ASC'
            }

        });

        if (!appUserQuery.result || appUserQuery.result.length === 0) {
            return;
        }

        // 2. 获取第一个审批人
        const approvers = Array.isArray(appUserQuery.result)
            ? appUserQuery.result
            : [appUserQuery.result];

        approvers.sort((a, b) => parseInt(a.APPSORT) - parseInt(b.APPSORT));

        const firstApprover = approvers[0];

        // 3. 发送微信模板消息（若有 openid）
        if (firstApprover.WXOPENID) {
            // await axios({
            //     method: 'post',
            //     url: v_url_wx_message,
            //     data: {
            //         p_action: firstApprover.WXOPENID,
            //         p_value: DIRNM,
            //         p_key2: localStorage.getItem('v_deptnm'),
            //         p_value2: initiator.empnm,
            //         p_key3: getDate('full'),
            //         p_value3: CNAME || ''
            //     }
            // }).catch(() => {

            // });
        }

        // 4. 更新审批人状态为待审批
        await axios({
            method: 'post',
            url: v_url_update,
            data: {
                p_key: 'IDSEQ',
                p_value: businessId,
                p_key2: 'LSTSEQ',
                p_value2: firstApprover.LSTSEQ,
                p_table: 'SYS_flow_appuser',
                p_cond: `SET STFG = 'P', UPDUSER = '${localStorage.getItem('v_usernm')}', UPDDTTM = '${getDate('full')}'`
            }
        });

        return true;
    } catch (error) {
        throw new Error(`发送微信模板消息失败: ${error.message}`);
    }
}

/**
 * 发送微信模板消息给下一个
 */
export function sendWeChatTemplateMessageS(options) {
    const {businessId, initiator, CNAME, DIRNM, axios, WXOPENID} = options;
    // return axios({
    //     method: 'post',
    //     url: v_url_wx_message,
    //     data: {
    //         p_action: WXOPENID,    // openid
    //         p_value: DIRNM,        // 目录名称
    //         p_key2: localStorage.getItem('v_deptnm'),  // 部门
    //         p_value2: initiator.empnm,           // 发起人
    //         p_key3: getDate('full'),             // 发起日期
    //         p_value3: CNAME || ''                // 文件名称
    //     }
    // }).catch(error => {
    //     throw error;
    // });

}

/**
 * 发送审批结果
 */
export function sendWeChatTemplateMessageToInitiator({businessId, initiator, CNAME, DIRNM, axios, WXOPENID, type}) {
    const typeStr = type === 'approve' ? '审批通过' : '审批驳回';
    // 模拟通知发起人
    // return axios({
    //     method: 'post',
    //     url: v_url_wx_message,
    //     data: {
    //         p_action: WXOPENID,    // openid
    //         p_value: DIRNM,        // 目录名称
    //         p_key2: localStorage.getItem('v_deptnm'),  // 部门
    //         p_value2: initiator.empnm,           // 发起人
    //         p_key3: getDate('full'),             // 发起日期
    //         p_value3: `${CNAME || ''} ${typeStr}`  // 文件名称
    //     }
    // })

}

function notifyInitiator({businessId, initiator, CNAME, DIRNM, axios, type}) {
    return axios({
        method: 'post',
        url: v_url_base,
        data: {
            p_table: 'SYS_flow_applog',
            p_key: 'IDSEQ',
            p_value: businessId,
            p_key2: 'LOGTY',
            p_value2: 'F',

        }
    }).then(res => {

        if (!res.result || res.result.length === 0) {

            return Promise.resolve();
        }

        const empno = res.result[0].EMPNO;

        return axios({
            method: 'post',
            url: v_url_base,
            data: {
                p_table: 'SYS_USER',
                p_key: 'USERNO',
                p_value: empno
            }
        }).then(userRes => {
            if (!userRes.result || userRes.result.length === 0) {
                return Promise.resolve();
            }

            const user = userRes.result[0];

            if (!user.WXOPENID) {
                return Promise.resolve();
            }

            // 发送微信模板消息
            // return sendWeChatTemplateMessageToInitiator({
            //     businessId,
            //     initiator,
            //     CNAME,
            //     DIRNM,
            //     axios,
            //     WXOPENID: user.WXOPENID,
            //     type
            // });
        });
    }).catch(() => {
        return Promise.resolve(); // 不影响主流程
    });
}

/**
 * 发送微信模板消息给抄送人
 */
export function sendWeChatTemplateMessageToCC(options) {
    const {businessId, initiator, CNAME, DIRNM, ccUser, axios, baseUrl} = options;

    // 检查抄送人是否有微信openid
    if (!ccUser.WXOPENID) {

        return Promise.resolve();
    }

    // 发送微信模板消息给抄送人
    // return axios({
    //     method: 'post',
    //     url: v_url_wx_message,
    //     data: {
    //         p_action: ccUser.WXOPENID,           // openid
    //         p_value: DIRNM,                      // 目录名称
    //         p_key2: localStorage.getItem('v_deptnm'),  // 部门
    //         p_value2: initiator.empnm,           // 发起人
    //         p_key3: getDate('full'),             // 通知日期
    //         p_value3: `${CNAME || ''} (抄送通知)` // 文件名称 + 抄送标识
    //     }
    // })

}

/**
 * 获取审批日志
 */
export async function getApprovalLogs(options) {
    const {businessId, axios, url} = options;

    try {
        const response = await axios({
            method: 'post',
            url: url,
            data: {
                p_table: 'SYS_flow_applog',
                p_key: 'IDSEQ',
                p_value: businessId,
                p_orderby: 'ADDDTTM ASC'
            }
        });

        return response.result || [];
    } catch (error) {
        throw new Error(`获取审批日志失败: ${error.message}`);
    }
}

/**
 * 获取文档审批状态
 * @returns {Promise<string>} 文档状态：'P'(审批进行中), 'Y'(审批通过), 'N'(未审核), 'R'(审批驳回)
 */
export async function getDocumentApprovalStatus(options) {
    const {businessId, axios, url,tableName} = options;

    try {
        const response = await axios({
            method: 'post',
            url: url,
            data: {
                p_table: tableName,
                p_key: 'IDSEQ',
                p_value: businessId
            }
        });

        if (response.result && response.result.length > 0) {
            const fileInfo = Array.isArray(response.result)
                ? response.result[0]
                : response.result;
            return fileInfo.STFG;
        }

        return null;
    } catch (error) {
        throw new Error(`获取文档审批状态失败: ${error.message}`);
    }
}

/**
 * 计算并保存预审批路径
 */
export async function calculateAndSaveApprovalPath(options) {
    const {flowId, businessId, actualInitiator, component, axios, baseUrl, businessData,tableName} = options;

    try {
        // 1. 加载流程数据（复用现有逻辑）
        const flowData = await loadWorkflowData({
            flowId: flowId,
            axios,
 
            url: v_url_base
        });

        if (!flowData || flowData.length === 0) {
            throw new Error('流程数据不存在');
        }

        // 2. 转换为前端格式
        const flatData = convertToProcessData(flowData);

        // 3. 构建树形结构
        const processTree = buildProcessTree(flatData);

        // 4. 计算预审批路径
        const approvalPath = calculateApprovalPath(processTree, businessId, actualInitiator, flowId, businessData);

        // 5. 保存到 sys_FLOW_APPUSER 表
        await saveApprovalPathToDatabase(approvalPath, {
            flowId,
            businessId,
            actualInitiator,
            component,
            axios,
            baseUrl
        });

        // 6. 记录流程发起日志
        await recordApprovalLog({
            businessId,
            empno: actualInitiator.empno,
            empnm: actualInitiator.empnm,
            stfg: 'Y',
            rmk: '发起人 发起',
            logty: 'F',
            refLstseq: '', // 发起人没有对应的LSTSEQ
            axios,
            baseUrl
        });

        // 7. 更新sys_FILE表状态为审批进行中
        // try {
        //     await axios({
        //         method: 'post',
        //         url: v_url_update,
        //         data: {
        //             p_cond: `SET STFG = 'P', UPDUSER = '${actualInitiator.empno}', UPDDTTM = '${getDate('full')}'`,
        //             p_table: tableName,
        //             p_key: 'IDSEQ',
        //             p_value: businessId
        //         }
        //     });

        // } catch (error) {
        //     console.error('更新'+tableName+'表状态失败:', error);
        // }

        return approvalPath;
    } catch (error) {
        throw new Error(`计算预审批路径失败: ${error.message}`);
    }
}

/**
 * 计算预审批路径
 * @param {Object} processTree - 流程树
 * @param {string} businessId - 业务ID
 * @param {Object} actualInitiator - 实际发起人
 * @param {string} flowId - 流程ID
 * @param {Object} businessData - 业务数据
 * @param {string} businessData.flowType - 流程类型：'1'(文档)、'2'(报销)、'3'(请假)
 * @param {number} businessData.qty - 数量（用于请假流程）
 * @param {number} businessData.amt - 金额（用于报销流程）
 */
function calculateApprovalPath(processTree, businessId, actualInitiator, flowId, businessData) {
    const approvalPath = [];
    const ccUsers = []; // 存储抄送人信息
    let currentSort = 1;

    /**
     * 评估条件表达式
     * @param {string} conditionString - 条件字符串，如 "qty<1" 或 "amt>=100"
     * @param {Object} businessData - 业务数据
     * @returns {boolean} 条件是否满足
     */
    function evaluateCondition(conditionString, businessData) {
        if (!conditionString || !businessData) return false;

        try {
            // 支持的操作符
            const operators = ['>=', '<=', '==', '!=', '>', '<'];
            let operator = null;
            let leftValue = null;
            let rightValue = null;

            // 查找操作符
            for (const op of operators) {
                if (conditionString.includes(op)) {
                    operator = op;
                    const parts = conditionString.split(op);
                    if (parts.length === 2) {
                        leftValue = parts[0].trim();
                        rightValue = parts[1].trim();
                        break;
                    }
                }
            }

            if (!operator || leftValue === null || rightValue === null) {
                console.warn('无法解析条件表达式:', conditionString);
                return false;
            }

            // 获取左侧字段的值
            let leftVal = businessData[leftValue];
            if (leftVal === undefined || leftVal === null) {
                console.warn(`业务数据中未找到字段: ${leftValue}`);
                return false;
            }

            // 转换右侧值的类型
            let rightVal = rightValue;
            if (!isNaN(rightValue)) {
                rightVal = parseFloat(rightValue);
                leftVal = parseFloat(leftVal);
            }

            // 执行比较
            switch (operator) {
                case '>=':
                    return leftVal >= rightVal;
                case '<=':
                    return leftVal <= rightVal;
                case '>':
                    return leftVal > rightVal;
                case '<':
                    return leftVal < rightVal;
                case '==':
                    return leftVal == rightVal;
                case '!=':
                    return leftVal != rightVal;
                default:
                    return false;
            }
        } catch (error) {
            console.error('条件表达式求值错误:', error, conditionString);
            return false;
        }
    }

    function traverseNode(node) {
        if (!node) return;

        const nodeType = node.type;

        // 处理不同类型的节点
        switch (nodeType) {
            case 0: // 发起人节点
                    // 发起人节点不保存到审批路径，只继续遍历子节点
                if (node.childNode) {
                    traverseNode(node.childNode);
                }
                break;

            case 1: // 审批人节点
                if (node.nodeUserType && node.nodeUserType.valueList) {
                    node.nodeUserType.valueList.forEach((userId, index) => {
                        const userName = node.nodeUserType.valueName ?
                            node.nodeUserType.valueName.split(',')[index] || userId : userId;

                        approvalPath.push({
                            IDSEQ: businessId,
                            FLOW_IDSEQ: flowId,
                            empno: userId,
                            EMPNM: userName,
                            APPSORT: currentSort++,
                            ISCC: '0',
                            STFG: 'N',
                            CORPID: getCorpid(),
                            RMK: `审核节点: ${node.nodeName}`,
                            ADDUSER: localStorage.getItem('v_usernm'),
                            ADDDTTM: getDate('full'),
                            UPDUSER: localStorage.getItem('v_usernm'),
                            UPDDTTM: getDate('full')
                        });
                    });
                }
                // 继续遍历子节点
                if (node.childNode) {
                    traverseNode(node.childNode);
                }
                break;

            case 2: // 抄送人节点
                if (node.nodeUserType && node.nodeUserType.valueList) {
                    node.nodeUserType.valueList.forEach((userId, index) => {
                        const userName = node.nodeUserType.valueName ?
                            node.nodeUserType.valueName.split(',')[index] || userId : userId;

                        // 将抄送人信息存储到临时数组，不立即添加到审批路径
                        ccUsers.push({
                            IDSEQ: businessId,
                            FLOW_IDSEQ: flowId,
                            empno: userId,
                            EMPNM: userName,
                            APPSORT: currentSort, // 使用当前排序号，在最后一个审批人之后
                            ISCC: '1',
                            STFG: 'Y',
                            CORPID: getCorpid(),
                            RMK: `抄送节点: ${node.nodeName}`,
                            ADDUSER: localStorage.getItem('v_usernm'),
                            ADDDTTM: getDate('full'),
                            UPDUSER: localStorage.getItem('v_usernm'),
                            UPDDTTM: getDate('full')
                        });
                    });
                }
                // 继续遍历子节点
                if (node.childNode) {
                    traverseNode(node.childNode);
                }
                break;

            case 3: // 条件节点
                    // 条件节点本身不参与审批，继续遍历子节点
                if (node.childNode) {
                    traverseNode(node.childNode);
                }
                break;

            case 4: // 路由节点
                    // 路由节点本身不参与审批，根据条件判断走哪个分支
                if (node.conditionNodes && node.conditionNodes.length > 0) {
                    // 根据流程类型确定是否需要条件判断
                    const flowType = businessData.flowType || 1;
                    let shouldEvaluateConditions = false;

                    // 只有报销（flowType=2）和请假（flowType=3）需要条件判断
                    if (flowType === 2 || flowType === 3) {
                        shouldEvaluateConditions = true;
                    }

                    if (shouldEvaluateConditions) {
                        // 根据条件判断走哪个分支
                        let matchedCondition = null;

                        // 按优先级排序条件节点
                        const sortedConditions = [...node.conditionNodes].sort((a, b) => {
                            const priorityA = parseInt(a.priorityLevel) || 0;
                            const priorityB = parseInt(b.priorityLevel) || 0;
                            return priorityA - priorityB;
                        });

                        // 查找第一个满足条件的分支
                        for (const conditionNode of sortedConditions) {
                            if (conditionNode.conditionString) {
                                if (evaluateCondition(conditionNode.conditionString, businessData)) {
                                    matchedCondition = conditionNode;
                                    break;
                                }
                            }
                        }

                        // 如果有匹配的条件，只遍历该分支
                        if (matchedCondition && matchedCondition.childNode) {
                            traverseNode(matchedCondition.childNode);
                        } else {
                            // 如果没有匹配的条件，可能需要默认处理
                            console.warn('没有匹配的条件分支，业务数据:', businessData);
                        }
                    } else {
                        // 文档流程（flowType=1）不需要条件判断，遍历所有分支
                        node.conditionNodes.forEach(conditionNode => {
                            if (conditionNode.childNode) {
                                traverseNode(conditionNode.childNode);
                            }
                        });
                    }
                }

                // 也遍历直接子节点（如抄送人）
                if (node.childNode) {
                    traverseNode(node.childNode);
                }
                break;
        }
    }

    // 从根节点开始遍历
    traverseNode(processTree);

    // 将所有抄送人添加到审批路径的最后
    ccUsers.forEach(ccUser => {
        approvalPath.push(ccUser);
    });


    return approvalPath;
}

/**
 * 保存审批路径到数据库
 */
async function saveApprovalPathToDatabase(approvalPath, options) {

    const {businessId, axios,} = options;

    try {
        // 1. 查询现有的审批路径记录
        const existingRecords = await axios({
            method: 'post',
            url: v_url_base,
            data: {
                p_table: 'SYS_flow_appuser',
                p_key: 'IDSEQ',
                p_value: businessId,
                p_key2: 'corpid',
                p_value2: getCorpid(),
            }
        });

        const existingUsers = existingRecords.result ?
            (Array.isArray(existingRecords.result) ? existingRecords.result : [existingRecords.result]) :
            [];

        // 2. 创建现有记录的映射表（区分审批人和抄送人的匹配逻辑）
        const existingMap = {};
        existingUsers.forEach(user => {
            // 抄送人只按EMPNO+ISCC匹配，审批人按EMPNO+ISCC+APPSORT匹配
            const key = user.ISCC === '1' ?
                user.EMPNO + '_' + user.ISCC :
                user.EMPNO + '_' + user.ISCC + '_' + user.APPSORT;
            existingMap[key] = user;
        });

        // 3. 创建新路径的映射表
        const newPathMap = {};
        approvalPath.forEach(user => {
            // 抄送人只按empno+ISCC匹配，审批人按empno+ISCC+APPSORT匹配
            const key = user.ISCC === '1' ?
                user.empno + '_' + user.ISCC :
                user.empno + '_' + user.ISCC + '_' + user.APPSORT;
            newPathMap[key] = user;
        });

        // 4. 分析差异，准备操作数组
        const toInsert = [];  // 需要新增的记录
        const toUpdate = [];  // 需要更新的记录
        const toDelete = [];  // 需要删除的记录

        // 4.1 遍历新路径，找出需要新增和更新的记录
        approvalPath.forEach(newUser => {
            // 抄送人只按empno+ISCC匹配，审批人按empno+ISCC+APPSORT匹配
            const key = newUser.ISCC === '1' ?
                newUser.empno + '_' + newUser.ISCC :
                newUser.empno + '_' + newUser.ISCC + '_' + newUser.APPSORT;
            const existingUser = existingMap[key];

            if (existingUser) {
                // 记录已存在，检查是否需要更新
                const needUpdate =
                    existingUser.EMPNM !== newUser.EMPNM ||
                    existingUser.FLOW_IDSEQ !== newUser.FLOW_IDSEQ ||
                    existingUser.RMK !== newUser.RMK ||
                    existingUser.APPDTTM !== null ||
                    existingUser.CORPID  == null ||
                    existingUser.APPSORT !== newUser.APPSORT; // 增加APPSORT的比较

                if (needUpdate) {
                    // 创建更新对象，避免empno和EMPNO重复
                    const updateUser = Object.assign({}, newUser);
                    delete updateUser.empno; // 删除小写的empno
                    updateUser.EMPNO = newUser.empno; // 设置大写的EMPNO
                    updateUser.LSTSEQ = existingUser.LSTSEQ; // 保持原有LSTSEQ
                    updateUser.STFG = existingUser.STFG; // 保持原有审批状态
                    updateUser.APPDTTM = null; // 审批时间设为null
                    updateUser.CORPID = getCorpid(); // 审批时间设为null
                    toUpdate.push(updateUser);
                }
            } else {
                // 新记录，需要插入
                // 创建新增对象，避免empno和EMPNO重复
                const insertUser = Object.assign({}, newUser);
                delete insertUser.empno; // 删除小写的empno
                insertUser.EMPNO = newUser.empno; // 设置大写的EMPNO
                //insertUser.CORPID= getCorpid()
                toInsert.push(insertUser);
            }
        });

        // 4.2 遍历现有记录，找出需要删除的记录
        existingUsers.forEach(existingUser => {
            // 抄送人只按EMPNO+ISCC匹配，审批人按EMPNO+ISCC+APPSORT匹配
            const key = existingUser.ISCC === '1' ?
                existingUser.EMPNO + '_' + existingUser.ISCC :
                existingUser.EMPNO + '_' + existingUser.ISCC + '_' + existingUser.APPSORT;

                console.log('Check existing key:', key, '=> Exists in newPath?', !!newPathMap[key], 'STFG:', existingUser.STFG);

            if (!newPathMap[key]) {
                // 只删除未审批的记录，已审批的记录保留以维护审批历史
                if (existingUser.STFG === 'N' || existingUser.STFG === 'P') {
                    toDelete.push(existingUser);
                }
            }
        });

        // 5. 执行数据库操作
        // 5.1 逐个删除不需要的记录
        if (toDelete.length > 0) {
            for (let i = 0; i < toDelete.length; i++) {
                const deleteItem = toDelete[i];
                await axios({
                    method: 'post',
                    url: v_url_delete,
                    data: {
                        p_key: 'LSTSEQ',
                        p_value: deleteItem.LSTSEQ,
                        p_table: 'SYS_flow_appuser'
                    }
                });
            }
        }

        // 5.2 批量新增记录
        if (toInsert.length > 0) {
            await axios({
                method: 'post',
                url: v_url_batch_save,
                data: {
                    p_json: JSON.stringify(toInsert),
                    p_table: 'SYS_flow_appuser',
                    p_action: 'S'
                }
            });
        }

        // 5.3 逐个更新记录
        if (toUpdate.length > 0) {
            console.log('toUpdate', toUpdate);
            for (let i = 0; i < toUpdate.length; i++) {
                const updateItem = toUpdate[i];
                const v_cond = 'SET EMPNM=\'' + (updateItem.EMPNM || '') +
                    '\', FLOW_IDSEQ=\'' + (updateItem.FLOW_IDSEQ || '') +
                    '\', RMK=\'' + (updateItem.RMK || '') +
                    '\', APPSORT=\'' + (updateItem.APPSORT || '') +
                    '\', UPDUSER=\'' + localStorage.getItem('v_usernm') +
                    '\', UPDDTTM=\'' + getDate('full') + '\',APPDTTM=NULL';

                await axios({
                    method: 'post',
                    url: v_url_update,
                    data: {
                        p_key: 'LSTSEQ',
                        p_value: updateItem.LSTSEQ,
                        p_table: 'SYS_flow_appuser',
                        p_cond: v_cond
                    }
                });
            }
        }
        return true;

    } catch (error) {
        throw new Error('保存审批路径失败: ' + error.message);
    }
}

/**
 * 启动工作流实例
 * @param {Object} options - 配置选项
 * @param {string} options.flowId - 流程ID
 * @param {string} options.businessId - 业务单据ID
 * @param {Object} options.actualInitiator - 实际发起人信息
 * @param {Object} options.component - 组件实例引用
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 * @param {string} options.docType - 单据类型（可选）
 * @param {string} options.CNAME - 公司名称（可选）
 * @param {string} options.DIRNM - 目录名称（可选）
 * @param {string} options.flowType - 流程类型
 * @param {string} options.amt - 金额
 * @param {string} options.qty - 数量
 * @returns {Promise<Array>} 审批路径数组
 */
export async function startWorkflowInstance(options) {
    try {
        // 计算并保存预审批路径
        const approvalPath = await calculateAndSaveApprovalPath(options);
        // 发送微信模板消息给第一个审批人
        try {
            await sendWeChatTemplateMessage({
                businessId: options.businessId,
                docType: options.docType || '审批',
                initiator: options.actualInitiator,
                CNAME: options.CNAME || '',
                DIRNM: options.DIRNM || '',
                jumpUrl: options.jumpUrl || '',
                axios: options.axios,
                baseUrl: options.baseUrl
            });
        } catch (error) {
            console.error('发送微信模板消息失败:', error);
        }

        return approvalPath;
    } catch (error) {
        throw new Error(`启动工作流失败: ${error.message}`);
    }
}

/**
 * 处理审批操作
 * @param {Object} options - 配置选项
 * @param {string} options.businessId - 业务单据ID
 * @param {string} options.approverId - 审批人ID
 * @param {string} options.approverName - 审批人姓名
 * @param {string} options.action - 审批动作：'approve' 或 'reject'
 * @param {string} options.comment - 审批意见
 * @param {Object} options.component - 组件实例引用
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 * @returns {Promise} 审批结果
 */
export function handleApproval(options) {
    const {
        businessId,
        approverId,
        approverName,
        comment,
        component,
        action,
        CNAME,
        DIRNM,
        FRUSER,
        axios,
        EMPNO,
        tableName,
        UPD_COND,
        CHKRMK
    } = options;
    const initiator = {
        empnm: FRUSER
    };
    // 查找当前审批人的审批记录
    return axios({
        method: 'post',
        url: v_url_base,
        data: {
            p_table: 'V_SYS_flow_appuser',
            p_key: 'IDSEQ',
            p_value: businessId,
            p_key2: 'USERNO',
            p_value2: EMPNO,
            p_key3: 'STFG',
            p_value3: 'P',
            p_key4: 'corpid',
            p_value4: getCorpid(),
        }
    }).then(approvalRecord => {

        if (!approvalRecord.result || approvalRecord.result.length === 0) {
            throw new Error('未找到待审批记录');
        }

        const record = approvalRecord.result[0];
        const approvalStatus = action === 'approve' ? 'Y' : 'N';

        // 更新审批状态
        return axios({
            method: 'post',
            url: v_url_update,
            data: {
                p_key: 'IDSEQ',
                p_value: businessId,
                p_key2: 'LSTSEQ',
                p_value2: record.LSTSEQ,
                p_table: 'SYS_flow_appuser',
                p_cond: `SET STFG = '${approvalStatus}', CHKRMK = '${comment || ''}', UPDUSER = '${localStorage.getItem('v_usernm')}', UPDDTTM = '${getDate('full')}',APPDTTM='${getDate('full')}'`
            }
        }).then(() => {
            axios({
                method: 'post',
                url: v_url_update,
                data: {
                    //p_cond: `SET STFG = 'P', UPDUSER = '${localStorage.getItem('v_usernm')}', UPDDTTM = '${getDate('full')}'`,
                    p_cond: `SET STFG = 'P' `,
                    p_table: tableName,
                    p_key: 'IDSEQ',
                    p_value: businessId
                }
            })
            // 记录审批日志
            return recordApprovalLog({
                businessId,
                empno: approverId,
                empnm: approverName,
                stfg: approvalStatus,
                rmk: action === 'approve' ? '审核人 通过' : '审核人 驳回',
                logty: 'A',
                refLstseq: record.LSTSEQ, // 关联当前审批人的LSTSEQ
                axios,
                baseUrl: '',
                CHKRMK: CHKRMK
            });


        }).then(() => {

            if (action === 'approve') {
                // 查找下一个审批人
                return axios({
                    method: 'post',
                    url: v_url_base,
                    data: {
                        p_table: 'V_SYS_flow_appuser',
                        p_key: 'IDSEQ',
                        p_value: businessId,
                        p_key2: 'STFG',
                        p_value2: 'N',
                        p_key3: 'ISCC',
                        p_value3: '0',
                        p_key4: 'corpid',
                        p_value4: getCorpid(),
                    }
                }).then(nextApprover => {
                    if (nextApprover.result && nextApprover.result.length > 0) {
                        // 存在下一个审批人
                        const nextApproverInfo = nextApprover.result[0];

                        if (nextApproverInfo.EMPNM) {
                            return axios({
                                method: 'post',
                                url: v_url_base,
                                data: {
                                    p_table: 'V_SYS_FLOW_APPUSER',
                                    p_key: 'IDSEQ',
                                    p_value: businessId,
                                    p_key2: 'STFG',
                                    p_value2: 'N',
                                    p_key3: 'ISCC',
                                    p_value3: '0',
                                    p_key4: 'EMPNM',
                                    p_value4: nextApproverInfo.EMPNM,
                                    p_key5: 'corpid',
                                    p_value5: getCorpid(),
                                }
                            }).then(nextApproverInforQuery => {
                                if (nextApproverInforQuery.result &&
                                    nextApproverInforQuery.result.length > 0) {
                                    const nextApproverInfor = nextApproverInforQuery.result[0];

                                    // 发送微信消息给下一个审批人
                                    // const sendWeChatPromise = sendWeChatTemplateMessageS({
                                    //     businessId,
                                    //     initiator: initiator,
                                    //     DIRNM: DIRNM,
                                    //     CNAME: CNAME,
                                    //     axios: axios,
                                    //     WXOPENID: nextApproverInfor.WXOPENID
                                    // }).catch(() => {
                                    //     return false; // 微信发送失败但不影响流程
                                    // });

                                    // 更新下一个审批人状态为待审批
                                    const updateStatusPromise = axios({
                                        method: 'post',
                                        url: v_url_update,
                                        data: {
                                            p_key: 'IDSEQ',
                                            p_value: businessId,
                                            p_key2: 'LSTSEQ',
                                            p_value2: nextApproverInfor.LSTSEQ,
                                            p_table: 'SYS_flow_appuser',
                                            p_cond: `SET STFG = 'P', UPDUSER = '${localStorage.getItem('v_usernm')}', UPDDTTM = '${getDate('full')}'`
                                        }
                                    }).catch(error => {
                                        throw error; // 状态更新失败需要抛出错误
                                    });

                                    return Promise.allSettled([sendWeChatPromise, updateStatusPromise])
                                        .then(([wechatResult, statusResult]) => {
                                            if (statusResult.status !== 'fulfilled') {
                                                throw statusResult.reason; // 中断流程但不输出错误
                                            }
                                            // 微信通知失败不影响流程，所以不处理
                                            return true;
                                        });
                                }
                                return Promise.resolve(true);
                            }).catch(() => {
                                return Promise.resolve(true);
                            });
                        } else {
                            return Promise.resolve(true);
                        }
                    } else {

                        // 更新发起审批表状态为已审批
                        return axios({
                            method: 'post',
                            url: v_url_update,
                            data: {
                                //p_cond: `SET STFG = 'Y', UPDUSER = '${localStorage.getItem('v_usernm')}', UPDDTTM = '${getDate('full')}'`,
                                p_cond:UPD_COND ,
                                p_table: tableName,
                                p_key: 'IDSEQ',
                                p_value: businessId
                            }
                        }).then(updateRes => {
                            // 审批完成后，通知抄送人并记录抄送日志
                            return axios({
                                method: 'post',
                                url: v_url_base,
                                data: {
                                    p_table: 'V_SYS_FLOW_APPUSER',
                                    p_key: 'IDSEQ',
                                    p_value: businessId,
                                    p_key2: 'STFG',
                                    p_value2: 'Y',
                                    p_key3: 'ISCC',
                                    p_value3: '1',
                                    p_key4: 'corpid',
                                    p_value4: getCorpid(),
                                }
                            });
                        }).then(ccUserQuery => {
                            if (ccUserQuery.result && ccUserQuery.result.length > 0) {
                                const ccPromises = ccUserQuery.result.map(ccUser => {
                                    return sendWeChatTemplateMessageToCC({
                                        businessId,
                                        initiator,
                                        CNAME,
                                        DIRNM,
                                        ccUser,
                                        axios,
                                        baseUrl: ''
                                    }).catch(() => {
                                        return Promise.resolve();
                                    }).then(() => {
                                        return recordApprovalLog({
                                            businessId,
                                            empno: ccUser.EMPNO,
                                            empnm: ccUser.EMPNM,
                                            stfg: 'Y',
                                            rmk: '抄送人 接收',
                                            logty: 'C',
                                            refLstseq: ccUser.LSTSEQ,
                                            axios,
                                            baseUrl: '',
                                            CHKRMK: CHKRMK
                                        });
                                    });
                                });

                                return Promise.all(ccPromises);
                            } else {
                                return Promise.resolve(); // 无抄送人
                            }
                        })
                            .then(() => {
                                return notifyInitiator({
                                    businessId,
                                    initiator,
                                    CNAME,
                                    DIRNM,
                                    axios,
                                    type: 'approve'
                                });
                            })
                            .catch(() => {
                                return true;
                            });
                    }
                });
            } else {
                // 驳回（审核人的驳回日志已在上面记录）
                // 更新发起审批表状态为审批驳回
                return axios({
                    method: 'post',
                    url: v_url_update,
                    data: {
                        //p_cond: `SET STFG = 'R', UPDUSER = '${localStorage.getItem('v_usernm')}', UPDDTTM = '${getDate('full')}'`,
                        p_cond: `SET STFG = 'R' `,
                        p_table: tableName,
                        p_key: 'IDSEQ',
                        p_value: businessId
                    }
                }).then(() => {

                    return notifyInitiator({businessId, initiator, CNAME, DIRNM, axios, type: 'reject'});
                }).catch(() => {
                    return true; // 即使更新状态失败，驳回操作本身是成功的
                });
            }
        });
    }).catch(error => {
        console.error('审批处理失败:', error);
        throw new Error(`审批处理失败: ${error.message}`);
    });
}

/**
 * 设计工作流
 * @param {Object} options - 配置选项
 * @param {Object} options.row - 流程数据行
 * @param {string} options.type - 操作类型：'view', 'add', 'edit'
 * @param {string} options.idseq - 流程ID
 * @param {Object} options.component - 组件实例引用
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 * @returns {Promise} 流程设计结果
 */
export async function designWorkflow(options) {
    const {row, component, axios, baseUrl,stfg} = options;
    const v_idseq = row['IDSEQ']

    // 先获取流程节点数据
    try {
        const flowData = await loadWorkflowData({
            flowId: v_idseq,
            axios,
 
            url: v_url_base
        });

        if (!flowData || flowData.length === 0) {
            component.$refs.workflowDialog.open('add', null);
            return;
        }

        try {
            // 将流程数据转换为前端组件需要的格式
            const flatData = convertToProcessData(flowData);

            // 保存扁平化的节点数据，用于后续删除操作
            component.flattenedNodeData = flowData;

            if (!flatData || flatData.length === 0) {
                component.$refs.workflowDialog.open('add', null);
                return;
            }

            // 构建树形结构
            const processData = buildProcessTree(flatData);

            if (!processData) {
                component.$refs.workflowDialog.open('add', null);
                return;
            }

            // 打开流程设计对话框并传入数据
            component.$refs.workflowDialog.open('edit', processData);
        } catch (error) {
           // component.prompt = '处理流程数据时出错';
           //component.promptWin = true;
            // 出错时也打开一个新的流程设计对话框
            component.$refs.workflowDialog.open('add', null);
        }
    } catch (error) {
        //component.prompt = '加载流程数据失败';
        //component.promptWin = true
        // 出错时打开一个新的流程设计对话框
        component.$refs.workflowDialog.open('add', null);
    }
}

/**
 * 加载流程数据
 * @param {Object} options - 选项
 * @param {string} options.flowId - 流程ID
 * @param {Object} options.axios - axios实例
 * @param {string} options.url - API URL
 * @returns {Promise<Array>} 流程节点数据
 */
export async function loadWorkflowData({flowId, axios, url}) {
    try {

        const nodesRes = await axios({
            method: 'post',
            url: url,
            data: {
                p_table: 'V_SYS_FLOW_NODE',
                p_key: 'REFIDSEQ',
                p_value: flowId,
                p_key2:'corpid',
                p_value2: getCorpid(),
            }
        });

        if (!nodesRes.result || nodesRes.result.length === 0) {
            return null;
        }

        const nodes = nodesRes.result;

        // 2. 提取需要查询用户类型和条件的节点ID
        const userNodeIds = nodes.filter(node => ['0', '1', '2', '4'].includes(node.NODETYPE)).map(node => node.IDSEQ);
        const condNodeIds = nodes.filter(node => node.NODETYPE === '3').map(node => node.IDSEQ);

        // 3. 并行获取用户类型和条件信息
        const [userTypes, conditions] = await Promise.all([
            fetchNodeUserTypes(userNodeIds, axios, url),
            fetchNodeConditions(condNodeIds, axios, url)
        ]);

        // 4. 构建完整的流程数据结构
        return nodes.map(node => buildNodeData(node, userTypes, conditions));
    } catch (error) {
        throw new Error('加载流程数据失败');
    }
}

/**
 * 获取节点用户类型信息
 * @param {Array} nodeIds - 节点ID数组
 * @param {Object} axios - axios实例
 * @param {string} url - API URL
 * @returns {Promise<Array>} 用户类型数据
 */
async function fetchNodeUserTypes(nodeIds, axios, url) {
    if (!nodeIds.length) return [];

    // 逐个查询用户信息
    const userTypePromises = nodeIds.map(nodeId =>
        axios({
            method: 'post',
            url: url,
            data: {
                p_table: 'V_SYS_FLOW_NODE_USER',
                p_key: 'IDSEQ',
                p_value: nodeId,

            }
        })
    );

    // 等待所有查询完成并合并结果
    const userTypeResults = await Promise.all(userTypePromises);
    return userTypeResults.reduce((acc, res) => {
        if (res && res.result) {
            return [...acc, ...(Array.isArray(res.result) ? res.result : [res.result])];
        }
        return acc;
    }, []);
}

/**
 * 获取节点条件信息
 * @param {Array} nodeIds - 节点ID数组
 * @param {Object} axios - axios实例
 * @param {string} url - API URL
 * @returns {Promise<Array>} 条件数据
 */
async function fetchNodeConditions(nodeIds, axios, url) {
    if (!nodeIds.length) return [];

    // 逐个查询条件信息
    const condPromises = nodeIds.map(nodeId =>
        axios({
            method: 'post',
            url: url,
            data: {
                p_table: 'V_SYS_FLOW_NODE_COND',
                p_key: 'IDSEQ',
                p_value: nodeId,

            }
        })
    );

    // 等待所有查询完成并合并结果
    const condResults = await Promise.all(condPromises);
    return condResults.reduce((acc, res) => {
        if (res && res.result) {
            return [...acc, ...(Array.isArray(res.result) ? res.result : [res.result])];
        }
        return acc;
    }, []);
}

/**
 * 构建单个节点数据
 * @param {Object} node - 节点数据
 * @param {Array} userTypes - 用户类型数据
 * @param {Array} conditions - 条件数据
 * @returns {Object} 构建后的节点数据
 */
function buildNodeData(node, userTypes, conditions) {
    // 节点的基础数据
    const nodeData = {
        NODEID: node.NODEID,
        NODENAME: node.NODENAME,
        NODETYPE: node.NODETYPE,
        ERROR: node.NODEERROR === '1',
        EXAMINEMODE: node.EXAMINEMODE || '',
        PRIORITYLEVEL: node.PRIORITYLEVEL || '',
        CONDITIONSTRING: node.CONDITIONSTRING || '',
        CONDITIONSTRINGNAME: node.CONDITIONSTRINGNAME || '',
        PREID: node.PREID || '',
        LVL: node.LVL || '',
        RN: node.RN || 0,
        IDSEQ: node.IDSEQ || ''
    };

    // 根据节点类型处理不同的详情数据
    if (['0', '1', '2'].includes(node.NODETYPE)) {
        // 发起人(0)、审核人(1)、抄送人(2)
        processUserTypeNode(nodeData, node, userTypes);
    } else if (node.NODETYPE === '3') {
        // 条件(3)
        processConditionNode(nodeData, node, conditions);
    } else if (node.NODETYPE === '4') {
        // 路由节点(4)
        nodeData.conditionNodes = [];
    }

    return nodeData;
}

/**
 * 处理用户类型节点
 * @param {Object} nodeData - 节点数据
 * @param {Object} node - 原始节点数据
 * @param {Array} userTypes - 用户类型数据
 */
function processUserTypeNode(nodeData, node, userTypes) {
    const userTypeData = userTypes.find(ut => ut.IDSEQ === node.IDSEQ);
    if (userTypeData) {
        nodeData.NODEUSERTYPE = {
            NODETYPE: userTypeData.USERTYPE || '',
            VALUE: userTypeData.USERVALUE || '',
            VALUENAME: userTypeData.VALUENAME || '',
            VALUELIST: userTypeData.VALUELIST ? userTypeData.VALUELIST.split(',') : []
        };

        // 特殊处理发起人节点
        if (node.NODETYPE === '0' || node.NODETYPE === 0) {
            // 如果type为空，设置为"ALL"
            if (!nodeData.NODEUSERTYPE.NODETYPE || nodeData.NODEUSERTYPE.NODETYPE === '') {
                nodeData.NODEUSERTYPE.NODETYPE = 'ALL';

                // 如果valueName为空，设置为"所有人"
                if (!nodeData.NODEUSERTYPE.VALUENAME || nodeData.NODEUSERTYPE.VALUENAME === '') {
                    nodeData.NODEUSERTYPE.VALUENAME = '所有人';
                }
            }
        }
    } else {
        // 初始化空的用户类型数据
        nodeData.NODEUSERTYPE = {
            NODETYPE: '',
            VALUE: '',
            VALUENAME: '',
            VALUELIST: []
        };

        // 发起人节点默认为所有人
        if (node.NODETYPE === '0' || node.NODETYPE === 0) {
            nodeData.NODEUSERTYPE.NODETYPE = 'ALL';
            nodeData.NODEUSERTYPE.VALUENAME = '所有人';
        }
    }
}

/**
 * 处理条件节点
 * @param {Object} nodeData - 节点数据
 * @param {Object} node - 原始节点数据
 * @param {Array} conditions - 条件数据
 */
function processConditionNode(nodeData, node, conditions) {
    4
    const nodeConditions = conditions.filter(c => c.IDSEQ === node.IDSEQ);
    nodeData.CONDITIONLIST = nodeConditions.map(c => ({
        LEFTFIELDS: c.LEFTFIELDS || '',
        CENTERFIELDS: c.CENTERFIELDS || '',
        RIGHTFIELDS: c.RIGHTFIELDS || '',
        LEFTFIELDSNAME: c.LEFTFIELDSNAME || '',
        LEFTFIELDSTYPE: c.LEFTFIELDSTYPE || ''
    }));

    // 如果没有条件数据，创建一个空的条件列表
    if (nodeData.CONDITIONLIST.length === 0) {
        nodeData.CONDITIONLIST = [];
    }
    // 生成conditionStringName和conditionString
    else if (nodeData.CONDITIONLIST.length > 0) {
        // 如果没有conditionStringName，则生成
        if (!nodeData.CONDITIONSTRINGNAME) {
            // 生成形如 "条件1 and 条件2 and 条件3" 的字符串
            const conditionParts = nodeData.CONDITIONLIST.map(cond =>
                `${cond.LEFTFIELDSNAME || ''}${cond.CENTERFIELDS || ''}${cond.RIGHTFIELDS || ''}`
            );
            nodeData.CONDITIONSTRINGNAME = conditionParts.join(' and ');
        }
        // 如果没有conditionString，则生成
        if (!nodeData.CONDITIONSTRING) {
            const conditionCodeParts = nodeData.CONDITIONLIST.map(cond =>
                `${cond.LEFTFIELDS || ''}${cond.CENTERFIELDS || ''}${cond.RIGHTFIELDS || ''}`
            );
            nodeData.CONDITIONSTRING = conditionCodeParts.join(' and ');
        }
    }
}

/**
 * 将后端流程数据转换为前端组件需要的格式
 * @param {Array} flowData - 流程数据
 * @returns {Array} 转换后的数据
 */
export function convertToProcessData(flowData) {
    if (!flowData || flowData.length === 0) return null;

    // 将数据转换为扁平结构，属性名改为小写
    const processedData = flowData.map(node => {
        // 基本节点数据
        const processedNode = {
            nodeId: node.NODEID,
            nodeName: node.NODENAME,
            type: Number(node.NODETYPE),
            error: node.ERROR || false,
            examineMode: node.EXAMINEMODE || '',
            priorityLevel: node.PRIORITYLEVEL || '',
            conditionString: node.CONDITIONSTRING || '',
            conditionStringName: node.CONDITIONSTRINGNAME || '',
            preId: node.PREID || '',
            level: node.LVL || '',
            rn: node.RN || 0,
            IDSEQ: node.IDSEQ || ''
        };

        // 处理用户类型数据
        if (['0', '1', '2'].includes(node.NODETYPE) || [0, 1, 2].includes(node.NODETYPE)) {
            if (node.NODEUSERTYPE) {
                processedNode.nodeUserType = {
                    type: node.NODEUSERTYPE.NODETYPE || '',
                    value: node.NODEUSERTYPE.VALUE || '',
                    valueName: node.NODEUSERTYPE.VALUENAME || '',
                    valueList: Array.isArray(node.NODEUSERTYPE.VALUELIST) ?
                        node.NODEUSERTYPE.VALUELIST :
                        (node.NODEUSERTYPE.VALUELIST ? node.NODEUSERTYPE.VALUELIST.split(',') : [])
                };

                // 特殊处理发起人节点
                if (node.NODETYPE === '0' || node.NODETYPE === 0) {
                    // 如果type为空，设置为"ALL"
                    if (!processedNode.nodeUserType.type || processedNode.nodeUserType.type === '') {
                        processedNode.nodeUserType.type = 'ALL';

                        // 如果valueName为空，设置为"所有人"
                        if (!processedNode.nodeUserType.valueName || processedNode.nodeUserType.valueName === '') {
                            processedNode.nodeUserType.valueName = '所有人';
                        }
                    }
                }
            } else {
                // 确保节点有nodeUserType属性
                processedNode.nodeUserType = {
                    type: '',
                    value: '',
                    valueName: '',
                    valueList: []
                };

                // 发起人节点默认为所有人
                if (node.NODETYPE === '0' || node.NODETYPE === 0) {
                    processedNode.nodeUserType.type = 'ALL';
                    processedNode.nodeUserType.valueName = '所有人';
                }
            }
        }

        // 处理条件数据
        if (node.NODETYPE === '3' || node.NODETYPE === 3) {
            if (Array.isArray(node.CONDITIONLIST) && node.CONDITIONLIST.length > 0) {
                // 为条件节点生成conditionStringName
                const conditionChildrenNodes = node.CONDITIONLIST.map(cond => ({
                    id: `${node.NODEID}_cond_${Math.random().toString(36).substring(2, 8)}`,
                    leftFileds: cond.LEFTFIELDS || '',
                    centerFileds: cond.CENTERFIELDS || '',
                    rightFileds: cond.RIGHTFIELDS || '',
                    leftFiledsName: cond.LEFTFIELDSNAME || '',
                    leftFiledsType: cond.LEFTFIELDSTYPE || ''
                }));

                processedNode.conditionList = [{
                    id: `${node.NODEID}_list`,
                    conditionChildrenNodes
                }];

                // 如果没有conditionStringName，则从条件子节点生成
                if (!processedNode.conditionStringName && conditionChildrenNodes.length > 0) {
                    // 生成形如 "条件1 and 条件2 and 条件3" 的字符串
                    const conditionParts = conditionChildrenNodes.map(condition =>
                        `${condition.leftFiledsName || ''}${condition.centerFileds || ''}${condition.rightFileds || ''}`
                    );
                    processedNode.conditionStringName = conditionParts.join(' and ');

                    // 同时设置conditionString，确保数据回显
                    if (!processedNode.conditionString) {
                        const conditionCodeParts = conditionChildrenNodes.map(condition =>
                            `${condition.leftFileds || ''}${condition.centerFileds || ''}${condition.rightFileds || ''}`
                        );
                        processedNode.conditionString = conditionCodeParts.join(' and ');
                    }
                }
            } else {
                // 初始化空的条件列表
                processedNode.conditionList = [{
                    id: `${node.NODEID}_list`,
                    conditionChildrenNodes: []
                }];
            }
        }

        // 路由节点初始化conditionNodes数组
        if (node.NODETYPE === '4' || node.NODETYPE === 4) {
            processedNode.conditionNodes = [];
        }

        return processedNode;
    });

    // 按RN排序确保节点顺序正确
    processedData.sort((a, b) => (parseInt(a.rn) || 0) - (parseInt(b.rn) || 0));

    return processedData;
}

/**
 * 构建流程树结构
 * @param {Array} flatData - 扁平化的流程数据
 * @returns {Object} 树状结构
 */
export function buildProcessTree(flatData) {
    if (!flatData || flatData.length === 0) return null;

    const idMap = {}; // 快速通过 nodeId 获取节点
    let root = null;

    // Step 1：初始化每个节点
    flatData.forEach(node => {
        const copy = {...node};
        copy.childNode = null;

        // 初始化特定类型节点的属性
        initializeNodeByType(copy);

        idMap[copy.nodeId] = copy;
    });

    // Step 2：构建节点关系
    flatData.forEach(node => {
        const current = idMap[node.nodeId];
        if (!current) return; // 跳过不存在的节点

        if (isConditionChildNode(node)) {
            // 条件节点的子节点
            attachToConditionNode(node, current, idMap);
        } else if (node.preId && idMap[node.preId]) {
            // 有父节点的普通节点
            attachToParentNode(node, current, idMap);
        } else if (!node.preId) {
            // 根节点
            root = current;
        }
    });

    // 如果没有找到根节点，尝试使用LVL为1的节点作为根节点
    if (!root) {
        root = findAlternativeRoot(flatData, idMap);
    }

    return root;
}

/**
 * 初始化特定类型节点的属性
 * @param {Object} node - 节点对象
 */
function initializeNodeByType(node) {
    const nodeType = node.type;
    const isRouter = nodeType === '4' || nodeType === 4;
    const isCondition = nodeType === '3' || nodeType === 3;

    // 路由节点初始化conditionNodes数组
    if (isRouter) {
        node.conditionNodes = [];
    }

    // 条件节点生成conditionStringName和conditionString
    if (isCondition && node.conditionList && node.conditionList.length > 0) {
        const conditionList = node.conditionList[0];
        if (conditionList && conditionList.conditionChildrenNodes && conditionList.conditionChildrenNodes.length > 0) {
            const firstCondition = conditionList.conditionChildrenNodes[0];

            // 生成conditionStringName
            if (!node.conditionStringName) {
                node.conditionStringName = `${firstCondition.leftFiledsName || ''}${firstCondition.centerFileds || ''}${firstCondition.rightFileds || ''}`;
            }

            // 生成conditionString
            if (!node.conditionString) {
                node.conditionString = `${firstCondition.leftFileds || ''}${firstCondition.centerFileds || ''}${firstCondition.rightFileds || ''}`;
            }
        }
    }
}

/**
 * 判断是否为条件节点的子节点
 * @param {Object} node - 节点对象
 * @returns {boolean} 是否为条件节点的子节点
 */
function isConditionChildNode(node) {
    return node.preId && node.preId.startsWith("cond_");
}

/**
 * 将节点挂载到条件节点下
 * @param {Object} node - 节点对象
 * @param {Object} current - 当前节点
 * @param {Object} idMap - 节点ID映射
 */
function attachToConditionNode(node, current, idMap) {
    const parentCond = idMap[node.preId];
    if (parentCond) {
        parentCond.childNode = current;
    }
}

/**
 * 将节点挂载到父节点下
 * @param {Object} node - 节点对象
 * @param {Object} current - 当前节点
 * @param {Object} idMap - 节点ID映射
 */
function attachToParentNode(node, current, idMap) {
    const parent = idMap[node.preId];
    const parentType = parent.type;
    const currentType = current.type;
    const isParentRouter = parentType === '4' || parentType === 4;
    const isCurrentCondition = currentType === '3' || currentType === 3;

    if (isParentRouter && isCurrentCondition) {
        // 路由节点的条件分支
        parent.conditionNodes.push(current);
        sortConditionNodes(parent.conditionNodes);
    } else if ((isParentRouter && !isCurrentCondition) || (!node.preId.startsWith("cond_") && !isCurrentCondition)) {
        // 路由节点的直接子节点或普通节点的子节点
        if (!parent.childNode) {
            parent.childNode = current;
        }
    }
}

/**
 * 按优先级排序条件节点
 * @param {Array} conditionNodes - 条件节点数组
 */
function sortConditionNodes(conditionNodes) {
    conditionNodes.sort((a, b) => {
        const priorityA = parseInt(a.priorityLevel) || 0;
        const priorityB = parseInt(b.priorityLevel) || 0;
        return priorityA - priorityB;
    });
}

/**
 * 查找备选根节点
 * @param {Array} flatData - 扁平化的流程数据
 * @param {Object} idMap - 节点ID映射
 * @returns {Object} 根节点
 */
function findAlternativeRoot(flatData, idMap) {
    const possibleRoot = flatData.find(node => node.level === '1' || node.level === 1);
    return possibleRoot ? idMap[possibleRoot.nodeId] : null;
}

/**
 * 处理流程保存
 * @param {Object} options - 配置选项
 * @param {Object} options.obj - 流程对象
 * @param {Array} options.deletedNodeIds - 需要删除的节点ID数组
 * @param {Object} options.component - 组件实例引用
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 * @param {Function} options.flattenProcessNode - 扁平化流程节点的函数
 * @returns {Promise} 保存结果
 */
export async function handleWorkflowSave(options) {
    const {obj, deletedNodeIds, component, axios, baseUrl,v_idseq} = options;

    const v_arr = flattenProcessNode(obj);

    if (!v_arr || v_arr.length === 0) {
        component.$message.warning('没有可保存的流程节点');
        return;
    }

    try {
        // 如果有指定的需要删除的节点IDs，优先删除它们
        if (Array.isArray(deletedNodeIds) && deletedNodeIds.length > 0) {
            await deleteSpecificNodes({
                nodeIds: deletedNodeIds,
                flattenedNodeData: component.flattenedNodeData,
                axios,
                baseUrl,
                component
            });
        }

        // 保存所有节点并获取保存结果
        await saveAllNodes({
            nodes: v_arr,
            v_idseq:  v_idseq,
            axios,
            baseUrl,
            v_url: v_url_base,
            v_url_update: v_url_update,
            v_usernm: component.v_usernm
        });

        // 清空扁平化节点数据
        component.flattenedNodeData = [];

        component.$message.success('流程保存成功');
        component.addWin = false;
        component.qryTabData()
    } catch (err) {
        component.prompt = err.message || '保存失败';
        component.promptWin = true;
    }
}

/**
 * 删除指定ID的节点
 * @param {Object} options - 配置选项
 * @param {Array} options.nodeIds - 节点ID数组
 * @param {Array} options.flattenedNodeData - 扁平化的节点数据
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 * @param {Object} options.component - 组件实例引用
 * @returns {Promise} 删除结果
 */
async function deleteSpecificNodes({nodeIds, flattenedNodeData, axios, baseUrl, component}) {
    if (!nodeIds || nodeIds.length === 0) return;

    try {
        // 从扁平化数据中获取要删除的节点信息
        const nodesToDelete = nodeIds.map(nodeId =>
            flattenedNodeData.find(node => node.IDSEQ === nodeId)
        ).filter(node => node); // 过滤掉未找到的节点

        // 创建一个节点ID到节点的映射
        const nodeIdMap = {};
        nodesToDelete.forEach(node => {
            nodeIdMap[node.IDSEQ] = node;
        });

        // 构建依赖关系图（哪些节点依赖于其他节点）
        const dependencyGraph = {};
        nodesToDelete.forEach(node => {
            dependencyGraph[node.IDSEQ] = [];
        });

        // 填充依赖关系
        nodesToDelete.forEach(node => {
            // 如果节点的PREID是要删除的节点之一，那么该节点依赖于PREID指向的节点
            if (node.PREID && nodeIdMap[node.PREID]) {
                dependencyGraph[node.PREID].push(node.IDSEQ);
            }
        });

        // 计算删除顺序
        const deleteOrder = [];
        const visited = new Set();
        const temp = new Set();

        // 拓扑排序(DFS)帮助函数
        const topologicalSort = (nodeId) => {
            if (temp.has(nodeId)) {
                // 检测到循环依赖，直接跳过
                return;
            }
            if (visited.has(nodeId)) {
                return;
            }

            temp.add(nodeId);

            // 先处理所有依赖节点
            for (const depNodeId of dependencyGraph[nodeId]) {
                topologicalSort(depNodeId);
            }

            temp.delete(nodeId);
            visited.add(nodeId);
            deleteOrder.push(nodeId);
        };

        // 对每个节点执行拓扑排序
        for (const nodeId in dependencyGraph) {
            if (!visited.has(nodeId)) {
                topologicalSort(nodeId);
            }
        }

        // 最后再按照LVL值从大到小排序作为第二优先级
        // 获取拓扑排序后的节点列表
        const sortedNodes = deleteOrder.map(nodeId => nodeIdMap[nodeId]);
        sortedNodes.sort((a, b) => {
            const lvlA = parseInt(a.LVL) || 0;
            const lvlB = parseInt(b.LVL) || 0;
            return lvlB - lvlA; // 从大到小排序
        });

        // 循环删除每个节点
        for (const nodeInfo of sortedNodes) {
            try {
                const nodeId = nodeInfo.IDSEQ;
                const nodeType = nodeInfo.NODETYPE;

                // 根据节点类型执行不同的删除操作
                if (nodeType === '3') {
                    // 条件节点：先删除条件记录
                    await axios({
                        method: 'post',
                        url: v_url_delete,
                        data: {
                            p_key: 'IDSEQ',
                            p_value: nodeId,
                            p_table: 'SYS_flow_node_cond',

                        }
                    });
                } else if (['0', '1', '2', '4'].includes(nodeType)) {
                    // 人员节点（发起人、审批人、抄送人）和路由节点：先删除用户记录
                    await axios({
                        method: 'post',
                        url: v_url_delete,
                        data: {
                            p_key: 'IDSEQ',
                            p_value: nodeId,
                            p_table: 'SYS_flow_node_user',

                        }
                    });
                }

                // 最后删除节点本身
                await axios({
                    method: 'post',
                    url: v_url_delete,
                    data: {
                        p_key: 'IDSEQ',
                        p_value: nodeId,
                        p_table: 'SYS_flow_node',
                        p_key2:'corpid',
                        p_value2: getCorpid(),
                    }
                });
            } catch (nodeError) {
                component.prompt = `删除节点ID: ${nodeInfo.IDSEQ} 失败: ${nodeError.message || '数据库错误'}`;
                component.promptWin = true;
            }
        }
    } catch (error) {
        component.prompt = `删除节点失败: ${error.message || '数据库错误'}`;
        component.promptWin = true;
    }
}

/**
 * 保存所有节点
 * @param {Object} options - 配置选项
 * @param {Array} options.nodes - 节点数组
 * @param {string} options.v_idseq - 流程ID
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 * @param {string} options.v_url - API URL
 * @param {string} options.v_url_update - 更新API URL
 * @param {string} options.v_usernm - 用户名
 * @returns {Promise} 保存结果
 */
function saveAllNodes({nodes, v_idseq, axios, baseUrl, v_url, v_url_update, v_usernm}) {
    return Promise.all(nodes.map(item => {
        // 准备节点基本信息
        const nodeData = {
            IDSEQ: item.IDSEQ || '',
            REFIDSEQ: v_idseq,
            NODEID: item.NODEID,
            CORPID: getCorpid(),
            NODENAME: item.NODENAME,
            NODETYPE: item.NODETYPE,
            NODEERROR: item.ERROR || '',
            STFG: '1',
            EXAMINEMODE: item.EXAMINEMODE || '',
            PRIORITYLEVEL: item.PRIORITYLEVEL || '',
            CONDITIONSTRING: item.CONDITIONSTRING || '',
            CONDITIONSTRINGNAME: item.CONDITIONSTRINGNAME || '',
            PREID: item.PREID || '',
            LVL: item.LVL || ''
        };

        // 声明一个闭包变量来存储节点ID
        let savedIdseq;

        // 保存节点
        return axios({
            method: 'post',
            url: v_url_save,
            data: {p_json: JSON.stringify(nodeData), p_table: 'SYS_flow_node', frmid: ''}
        }).then(nodeRes => {
            if (nodeRes.code !== '200') {
                throw new Error(`节点 ${item.NODENAME || item.NODEID} 保存失败` );
            }

            // 保存ID到闭包变量
            savedIdseq = nodeRes.idseq;

            // 处理用户数据
            if (item.NODEUSERTYPE) {
                return axios({
                    method: 'post',
                    url: v_url,
                    data: {p_key: 'idseq', p_value: savedIdseq, p_table: 'SYS_flow_node_user' }
                });
            }
            return Promise.resolve(null); // 如果没有用户类型，返回已解决的Promise
        }).then(userRes => {
            // 如果是发起人节点且类型为"所有人"，不保存用户数据
            if ((item.NODETYPE === '0' || item.NODETYPE === 0) &&
                item.NODEUSERTYPE && item.NODEUSERTYPE.NODETYPE === 'ALL') {
                // 如果数据库中已有用户数据记录，则删除
                if (userRes   && userRes.result && userRes.result.length > 0) {
                    return axios({
                        method: 'post',
                        url: v_url_delete,
                        data: {
                            p_key: 'IDSEQ',
                            p_value: savedIdseq,
                            p_table: 'SYS_flow_node_user',

                        }
                    });
                }

                return Promise.resolve(); // 跳过保存用户数据
            }

            if (userRes) {
                if (userRes.result && userRes.result.length > 0) {
                    // 已存在用户数据，更新
                    let v_cond = ' set VALUENAME=\'' + (item.NODEUSERTYPE.VALUENAME || '') +
                        '\' ,VALUELIST=\'' + (item.NODEUSERTYPE.VALUELIST ? item.NODEUSERTYPE.VALUELIST.join(',') : '') +
                        '\' , USERTYPE=\'' + (item.NODEUSERTYPE.NODETYPE || '') +
                        '\' , UPDUSER=\'' + v_usernm + '\' , UPDDTTM=\'' + getDate('full') +
                        '\' ,USERVALUE=\'' + (item.NODEUSERTYPE.VALUE || '') + '\'';

                    return axios({
                        method: 'post',
                        url: v_url_update,
                        data: {
                            p_key: 'idseq',
                            p_value: savedIdseq,
                            p_key2: 'lstseq',
                            p_value2: userRes.result[0].LSTSEQ,
                            p_table: 'SYS_flow_node_user',
                            p_cond: v_cond
                        }
                    });
                } else if (item.NODEUSERTYPE) {
                    // 如果是发起人节点且类型为"所有人"，不创建用户数据记录
                    if ((item.NODETYPE === '0' || item.NODETYPE === 0) &&
                        item.NODEUSERTYPE.NODETYPE === 'ALL') {
                        return Promise.resolve();
                    }

                    // 不存在用户数据，新增
                    const userData = {
                        IDSEQ: savedIdseq,
                        LSTSEQ: '',
                        VALUENAME: item.NODEUSERTYPE.VALUENAME || '',
                        VALUELIST: item.NODEUSERTYPE.VALUELIST ? item.NODEUSERTYPE.VALUELIST.join(',') : '',
                        USERTYPE: item.NODEUSERTYPE.NODETYPE || '',
                        USERVALUE: item.NODEUSERTYPE.VALUE || '',
                        RMK: ''
                    };

                    return axios({
                        method: 'post',
                        url: v_url_dtl_save,
                        data: {p_json: JSON.stringify(userData), p_table: 'SYS_flow_node_user', p_idseq: savedIdseq}
                    });
                }
            }
            return Promise.resolve(); // 如果没有用户数据，返回已解决的Promise
        }).then(() => {
            // 处理条件数据
            if (Array.isArray(item.CONDITIONLIST) && item.CONDITIONLIST.length > 0) {
                return axios({
                    method: 'post',
                    url: v_url,
                    data: {p_key: 'idseq', p_value: savedIdseq, p_table: 'SYS_flow_node_cond' }
                }).then(condRes => {
                    if (condRes.result && condRes.result.length > 0) {
                        // 使用批量删除API删除所有现有条件记录
                        return axios({
                            method: 'post',
                            url: v_url_batch_save,
                            data: {
                                p_json: JSON.stringify(condRes.result),
                                p_table: 'SYS_flow_node_cond',
                                p_idseq: savedIdseq,
                                p_action: 'D'
                            }
                        }).then(() => {
                            // 保存新的条件
                            return saveNewConditions({
                                conditionList: item.CONDITIONLIST,
                                savedIdseq,
                                axios,
                                baseUrl
                            });
                        });
                    } else {
                        // 直接保存新条件，不需要删除
                        return saveNewConditions({
                            conditionList: item.CONDITIONLIST,
                            savedIdseq,
                            axios,
                            baseUrl
                        });
                    }
                });
            }
            return Promise.resolve(); // 如果没有条件数据，返回已解决的Promise
        }).then(() => {
            // 返回节点和ID信息，使用保存在闭包中的ID
            return {
                node: item,
                idseq: savedIdseq
            };
        });
    }));
}

/**
 * 保存新的条件记录
 * @param {Object} options - 配置选项
 * @param {Array} options.conditionList - 条件列表
 * @param {string} options.savedIdseq - 已保存的ID
 * @param {Object} options.axios - axios实例
 * @param {string} options.baseUrl - API基础URL
 * @returns {Promise} 保存结果
 */
function saveNewConditions({conditionList, savedIdseq, axios, baseUrl}) {
    if (!conditionList || conditionList.length === 0) {
        return Promise.resolve();
    }

    const condDataArray = conditionList.map(cond => ({
        IDSEQ: savedIdseq,
        LSTSEQ: '',
        LEFTFIELDS: cond.LEFTFIELDS || '',
        CENTERFIELDS: cond.CENTERFIELDS || '',
        RIGHTFIELDS: cond.RIGHTFIELDS || '',
        LEFTFIELDSNAME: cond.LEFTFIELDSNAME || '',
        LEFTFIELDSTYPE: cond.LEFTFIELDSTYPE || '',
    }));

    // 使用批量保存API保存所有条件
    return axios({
        method: 'post',
        url: v_url_batch_save,
        data: {
            p_json: JSON.stringify(condDataArray),
            p_table: 'SYS_flow_node_cond',
            p_action: 'S'
        }
    });
}
